import { render, staticRenderFns } from "./RutasPantalla.vue?vue&type=template&id=f37069e4&"
import script from "./RutasPantalla.vue?vue&type=script&lang=ts&"
export * from "./RutasPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f37069e4', component.options)
    } else {
      api.reload('f37069e4', component.options)
    }
    module.hot.accept("./RutasPantalla.vue?vue&type=template&id=f37069e4&", function () {
      api.rerender('f37069e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Ruta/RutasPantalla.vue"
export default component.exports